import { createFileRoute } from '@tanstack/react-router'
import ImportStockChanges from 'Imports/components/StockChanges/ImportStockChanges'

import { Guard } from '../-guard'

export const Route = createFileRoute('/imports/importstockchanges')({
    component: () => (
        <Guard claims={['opus_royalty']}>
            <ImportStockChanges />
        </Guard>
    ),
})
